import { _ as __assign, b as __awaiter, c as __generator } from '../../chunks/bundle-Ca6003_X.js';
import React__default from 'react';
import { u as useGroupChannel } from '../../chunks/bundle-CGu41Cov.js';
import { F as FileViewerView } from '../../chunks/bundle-BizIEQwt.js';
import { u as useSendbird } from '../../chunks/bundle-ByN2OJfK.js';
import '@sendbird/chat/message';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-Dwuqku8L.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '../../chunks/bundle-DxuHs_7y.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../chunks/bundle-CyNQH9Yl.js';
import '../../chunks/bundle-B2eoNpzc.js';
import '../../chunks/bundle-_G98ZxIs.js';
import '../../chunks/bundle-CiiVQ3uH.js';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import 'react-dom';
import '../../chunks/bundle-zHBlW_wn.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CCo7ZdMR.js';
import '../../chunks/bundle-s19NuPaM.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../chunks/bundle-CPSJLEbT.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';

var FileViewer = function (props) {
    var _a = useGroupChannel(), onBeforeDownloadFileMessage = _a.state.onBeforeDownloadFileMessage, deleteMessage = _a.actions.deleteMessage;
    var logger = useSendbird().state.config.logger;
    return (React__default.createElement(FileViewerView, __assign({}, props, { deleteMessage: deleteMessage, onDownloadClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!onBeforeDownloadFileMessage)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: props.message })];
                    case 2:
                        allowDownload = _c.sent();
                        if (!allowDownload) {
                            e.preventDefault();
                            (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'FileViewer: Not allowed to download.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'FileViewer: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); } })));
};

export { FileViewer, FileViewer as default };
//# sourceMappingURL=FileViewer.js.map
